import { render, staticRenderFns } from "./PositionChangeReason.vue?vue&type=template&id=59b0ab4c"
import script from "./PositionChangeReason.vue?vue&type=script&lang=js"
export * from "./PositionChangeReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports